<app-vertical-grouped-bar  [colorScheme]="colorScheme" [data]="data"></app-vertical-grouped-bar>
